import { withInstall } from '@vuemap/vue-amap-util'
import MassMarks from './MassMarks.vue'

export const ElAmapMassMarks = withInstall(MassMarks)
export default ElAmapMassMarks
